import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import "./Vervangwagen.css";
import Suzuki from "../../assets/img/vervangwagens/suzuki.png";
import MainCar from "../../assets/img/main_background_foto.png";
import Mercedes from "../../assets/img/vervangwagens/mercedes.png";
import FordTransit from "../../assets/img/vervangwagens/ford.png";
import p208 from "../../assets/img/vervangwagens/208.png";
import p2008 from "../../assets/img/vervangwagens/2008.png";
import citroen from "../../assets/img/vervangwagens/citroen.png";

const LUXURY = [0.16, 1, 0.3, 1];

const cars = [
  { image: MainCar, name: "Renault Captur" },
  { image: Suzuki, name: "Suzuki Swift" },
  { image: p208, name: "Peugeot 208" },
  { image: p2008, name: "Peugeot 2008" },
  { image: Mercedes, name: "Mercedes CLA" },
  { image: FordTransit, name: "Ford Transit" },
  { image: citroen, name: "Citroën C3" },
  { image: p2008, name: "Peugeot 2008" },
  { image: null, name: "Toyota Corolla" },
];

export default function Vervangwagen() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-10%" });

  return (
    <section id="vervangwagen" className="vervangwagen-section" ref={ref}>
      <div className="vervangwagen-container">

        {/* ── Header with mask-reveal title ── */}
        <div className="vervangwagen-header">
          <motion.span
            className="section-badge"
            initial={{ opacity: 0, y: 12 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, ease: LUXURY }}
          >
            Mobiliteit
          </motion.span>

          {/* Mask-reveal: outer clips, inner slides up */}
          <div className="title-mask">
            <motion.h2
              className="vervangwagen-title"
              initial={{ y: "110%" }}
              animate={isInView ? { y: "0%" } : {}}
              transition={{ duration: 0.85, delay: 0.1, ease: LUXURY }}
            >
              Vervangwagens voor onze klanten.
            </motion.h2>
          </div>

          <motion.p
            className="vervangwagen-intro"
            initial={{ opacity: 0, y: 16 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.28, ease: LUXURY }}
          >
            Bij ons staat uw mobiliteit centraal. Wanneer uw wagen bij ons in
            herstelling is, zorgen wij dat u gewoon verder kunt rijden. Gratis
            bij verzekeringsherstel, tegen kleine vergoeding in overige gevallen.
          </motion.p>
        </div>

        {/* ── Technical Note info box ── */}
        <motion.div
          className="vervangwagen-info"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.75, delay: 0.4, ease: LUXURY }}
        >
          <span className="info-label">Info // Mobiliteit</span>
          <p>
            Wanneer de schade buiten de verzekering om wordt hersteld, kunt u
            nog steeds gebruikmaken van onze vervangwagens. In dat geval vragen
            wij hiervoor een kleine vergoeding. Geef dit aan bij het plannen van
            uw afspraak en wij regelen de rest.
          </p>
        </motion.div>

        {/* ── Fleet gallery ── */}
        <div className="cars-section">
          <motion.div
            className="cars-section-header"
            initial={{ opacity: 0, y: 16 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.65, delay: 0.5, ease: LUXURY }}
          >
            <span className="cars-section-line" />
            <h3 className="cars-section-title">Onze vervangwagens</h3>
          </motion.div>

          <div className="cars-grid">
            {cars.map((car, i) => (
              <motion.div
                key={i}
                className="car-card"
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.65, delay: 0.55 + i * 0.07, ease: LUXURY }}
              >
                <div className="car-image-container">
                  {car.image ? (
                    <motion.img
                      src={car.image}
                      alt={car.name}
                      className="car-image"
                      whileHover={{ scale: 1.03 }}
                      transition={{ duration: 1.4, ease: LUXURY }}
                    />
                  ) : (
                    <div className="car-placeholder">
                      <span className="placeholder-name">{car.name}</span>
                    </div>
                  )}
                </div>
                <div className="car-info">
                  <h4 className="car-name">{car.name}</h4>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
